<template>
  <div>
    <vue-headful title="Alabama Interactive Map - Beaches, Cities and Places To Go"
      description="Plan your next trip to Alabama with this detailed interactive map." />
    <trips-nav />
    <div :class="isMobile ? 'mobile-slide' : ''">
      <div v-if="showNav" class="my-trips-nav">
        <div class="my-trip-header">My Trip</div>
        <b-breadcrumb class="mytrip-breadcrumbs">
          <b-breadcrumb-item href="#" :active="!showCompanions" class="my-trip-name"><span href="#"
              @click="showLocations">{{ this.getTripById(this.tripId).name }}</span></b-breadcrumb-item>
          <b-breadcrumb-item v-if="showCompanions" :active="showCompanions"><span
              class="my-trip-label">Companions</span></b-breadcrumb-item>
        </b-breadcrumb>
        <div class="my-trip-actions">
          <span v-if="isOwner" @click="editTrip" class="action-set">
            <img class="" src="/images/icons/edit-trip.svg" /> Edit Trip
          </span>
          <span @click="collaborate" class="action-set">
            <img class="" src="/images/icons/friends.svg" /> Companions
          </span>
          <span v-on:click="manageTrip" class="action-set">
            <img src="/images/icons/manage-trip.svg" /> Manage Trips
          </span>
        </div>
      </div>
      <div v-if="showCompanions" class="companions">
        <companions :userId="userId" :trip="this.getTripById(this.tripId)" />
      </div>
      <div v-if="showEdit" class="edit-trip">
        <edit :tripInfo="this.getTripById(this.tripId)" />
      </div>
      <map-list v-if="showList" class="listed-results" :tripId="tripId" :pin="locations" />
    </div>
    <dynamic-map v-if="myTripsLoaded" :pins="locations" :type="this.type" class="map-container" />
    <div v-if="showList && isMobile" class="mobile-button-container">
      <button @click="toggleList" class="view-list-button">
        <img v-if="!showingMap" class="button-icon" src="/images/icons/view-list-icon.svg" />
        <img v-else class="button-icon" src="/images/icons/view-map-icon.svg" />{{ button.text }}
      </button>
    </div>
  </div>
</template>

<script>
import DynamicMap from '@/components/Maps/Map.vue';
import MapList from '@/components/Maps/MapList.vue';
import Companions from '@/components/MyTrips/Companions.vue';
import Edit from '@/components/MyTrips/Edit.vue';
import { Auth } from 'aws-amplify';
import axios from 'axios';
import { BBreadcrumb, BBreadcrumbItem } from 'bootstrap-vue';
import { mapActions, mapGetters } from 'vuex';
import TripsNav from '../components/Maps/TripsNav.vue';

export default {
  name: 'trip-details',
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    DynamicMap,
    MapList,
    Edit,
    Companions,
    TripsNav,
  },
  props: {
    type: {
      type: String,
    },
    area: {
      type: String,
    },
  },
  data() {
    return {
      button: {
        text: 'View Map',
      },
      isMobile: false,
      showingMap: true,
      showingList: false,
      loaded: false,
      locations: [],
      currentLocations: [],
      trips: null,
      showNav: true,
      showEdit: false,
      showFav: false,
      showList: true,
      showCompanions: false,
      tripId: '',
      loading: true,
      isOwner: false,
    };
  },
  async created() {
    const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
    this.userId = await user.username.replace(/[@.]/g, '|');
    this.tripId = this.$route.path.replace('/trip/', '');
    this.trip = await this.getTripById(this.tripId);
    this.isOwner = this.trip.owner === this.userId;
    this.$root.$on('updateWaypoints', async () => {
      await this.loadMyTrips();
      await this.userLocations();
      this.$root.$emit('updateWaypointsDone');
    });
    await this.loadMyTrips();
    await this.userLocations();
    this.setParams();
    this.mq();
  },
  methods: {
    ...mapActions({
      loadMyTrips: 'myTrips/loadMyTrips',
    }),
    mq() {
      const chatStyle = document.querySelector('.a5-widget-container');
      this.width = document.documentElement.clientWidth;
      if (this.width < 930) {
        this.isMobile = true;
        if (chatStyle && chatStyle.style !== null) {
          chatStyle.style.display = 'none';
        }
      } else {
        this.isMobile = false;
        if (chatStyle && chatStyle.style !== null) {
          chatStyle.style.display = 'block';
        }
      }
    },
    buttonSlider() {
      this.showingList = !this.showingList;
      const listedResults = document.querySelector('.listed-results');
      if (this.showingList) {
        listedResults.classList.add('slide');
      } else {
        listedResults.classList.remove('slide');
      }
    },
    async userLocations() {
      try {
        const destination = this.myTrips.filter(trip => trip.tripId === this.tripId);
        const [{ tripId: id, routing }] = destination;
        const destinationPin = {
          id,
          name: routing.end.city,
          position: {
            lat: Number(routing.end.lat),
            lng: Number(routing.end.long),
          },
          show: true,
          dest: true,
        };
        let beginPin = {};
        if (routing.end.city !== routing.begin.city) {
          beginPin = {
            id,
            name: routing.begin.city ? routing.begin.city : routing.end.city,
            position: {
              lat: routing.begin.lat ? Number(routing.begin.lat) : Number(routing.end.lat),
              lng: routing.begin.long ? Number(routing.begin.long) : Number(routing.end.long),
            },
            show: true,
            begin: true,
          };
        }
        const myLocations = [];
        const tripInfo = await this.getTripById(this.tripId).tripInfo;

        // eslint-disable-next-line
        for (const trip of tripInfo) {
          const idList = trip.locationId;
          // eslint-disable-next-line
          const res = await axios.get(`${process.env.VUE_APP_API2}locationsByIdList?id=${idList}`, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              Accept: 'application/json',
            },
          });

          if (res && res.data) {
            const locationInfo = res.data;
            const completeLocationInfo = locationInfo.map(obj => ({ ...obj, show: trip.show }));
            myLocations.push(completeLocationInfo);
          }
        }
        myLocations.push(JSON.parse(JSON.stringify(destinationPin)));
        if (routing.end.city !== routing.begin.city) {
          myLocations.push(JSON.parse(JSON.stringify(beginPin)));
        }
        this.locations = myLocations.flat();
      } catch (error) {
        console.log(error);
      }
    },
    handleEvent(data) {
      this.$props.myLocations = [...this.$props.myLocations.map((loc) => {
        if (loc.id === data.id) {
          return { ...loc, favoritedLoc: data.favoritedLoc };
        }
        return loc;
      })];
    },
    locationSelected() {
      this.$emit('locationSelected');
    },
    async toggleList() {
      const mobileSlide = document.querySelector('.mobile-slide');
      const listedResults = document.querySelector('.listed-results');
      const chatStyle = document.querySelector('.a5-widget-container');
      this.showingMap = !this.showingMap;
      this.button.text = !this.showingMap ? this.button.text = 'View List' : this.button.text = 'View Map';
      if (!this.showingMap) {
        listedResults.classList.remove('slide');
        mobileSlide.classList.add('open');
        if (chatStyle && chatStyle.style !== null) {
          chatStyle.style.display = 'none';
        }
      } else {
        listedResults.classList.remove('slide');
        mobileSlide.classList.remove('open');
        if (chatStyle && chatStyle.style !== null) {
          chatStyle.style.display = 'none';
        }
      }
    },
    showLocations() {
      this.showCompanions = false;
      this.showNav = true;
      this.showEdit = false;
      this.showFav = false;
      this.showList = true;
    },
    editTrip() {
      this.showCompanions = false;
      this.showEdit = true;
      this.showNav = false;
      this.showFav = false;
      this.showList = false;
    },
    collaborate() {
      this.showCompanions = true;
      this.showNav = true;
      this.showEdit = false;
      this.showFav = false;
      this.showList = false;
    },
    async manageTrip() {
      const userId = await this.getTripById(this.tripId).owner.replace(/-/g, '');
      await this.$router.push({ name: 'mytrip-list', params: { id: userId } });
    },
    showCrisis() {
      return this.$store.state.crisisManager.alert && !this.$store.state.crisisManager.collapsed;
    },
    async setParams() {
      // handle the type being passed in
      if (this.type && this.type !== 'all') {
        const tabType = this.type;
        await this.$store.dispatch('maps/setLoading', true);
        await this.$store.dispatch('maps/resetSelectedLocation');
        await this.$store.dispatch('maps/setSelectedTab', tabType);
      }
      if (this.area && this.area !== 'all') {
        await this.$store.dispatch('maps/setArea', this.area);
      }
    },
  },
  computed: {
    ...mapGetters({
      myTrips: 'myTrips/myTrips',
      myTripsLoaded: 'myTrips/loaded',
      getTripById: 'myTrips/getTripById',
      uniqueLocations: 'myTrips/getUniqueLocations',
    }),
  },
  mounted() {
    this.$store.state.maps.filter.area = '';
    window.addEventListener('resize', this.mq);
  },
  unmounted() {
    window.removeEventListener('resize', this.mq);
  },
  async myTrips() {
    const self = this;
    await self.userLocations();
  },
  async $route() {
    const newTripId = this.$route.path.replace('/trip/', '');
    if (this.tripId !== newTripId) {
      this.locations = [];
      this.tripId = newTripId;
      await this.userLocations();
    }
  },
};
</script>

<style lang="scss" scoped>
.my-trips {
  grid-area: my-trips;
  display: grid;
  grid-template-columns: auto auto;
  padding: 0px;
  width: 328px;
  height: auto;
  margin-left: 27px;
  margin-top: 0px;

  @media only screen and (max-width: 640px) {
    grid-template-columns: auto;
  }
}

.my-trips-empty {
  padding: 0px;
  width: 25%;
  height: auto;
  margin: 75px 0 0 200px;

  @media only screen and (max-width: 768px) {
    grid-template-columns: auto;
    margin-left: auto;
    margin-right: auto;
  }
}

.map-container {
  left: 0;
  position: absolute;
  top: 94px;
  z-index: 1;

  @media only screen and (min-width: 1024px) {
    left: 50%;
    top: 160px;
    width: 50%;
  }
}

.my-trip-header {
  grid-area: header;
  margin-top: 31px;
  font-family: "KlinicSlabbold";
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--dark-blue-300);
  text-align: left;
  margin-left: 60px;
}

.mytrip-breadcrumbs {
  padding-bottom: 0;
  font-size: 16px;
  color: #6daab2 !important;


  .my-trip-name {
    font-family: 'KlinicSlabbold';
    color: #6daab2 !important;
    font-size: 16px;
    font-weight: bolder;
  }

  .my-trip-label {
    font-family: 'KlinicSlabbold';
    font-size: 16px;
    font-weight: bold;
  }
}

.my-trip-filter {
  grid-area: filter;
  display: flex;
  justify-content: flex-end;
  margin: 5px 20px 0 0;
  font-family: "KlinicSlab";
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #6daab2;
  margin-right: 60px;
}

.my-trip-actions {
  text-align: left;
  margin-left: 60px;

  @media only screen and (max-width: 930px) {
    .action-set {
      margin-right: 20px !important;
    }
  }

}

.filter-tx {
  cursor: pointer;
}

.my-trip-actions {
  grid-area: action;
}

.action-set {
  margin-right: 27px;
  font-family: "IdealSans-Medium";
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--dark-blue-300);
  cursor: pointer;
}

.edit-trip {
  overflow: scroll;
  height: 100vh;
}

.my-trips-nav {
  display: grid;
  width: 100%;
  margin-top: 75px;
  grid-template-areas: "header header"
    "name filter"
    "action .";

  @media only screen and (max-width: 1028px) {
    margin-top: 0px;
    margin-left: 20px;
    grid-template-areas: "header header"
      "name filter"
      "action .";
  }

  @media only screen and (min-width: 1028px) {
    margin-left: 50px;
  }
}

.my-trip-header,
.my-trip-name,
.my-trip-actions {
  margin-left: 8px;
}

.mobile-button-container {
  display: flex;
  justify-content: center;
}

.button-icon {
  margin-right: var(--spacing-xs);
}

.view-list-button {
  align-items: center;
  background: #173945;
  border: 1px solid #173945;
  border-radius: 20px;
  bottom: 6rem;
  color: #fff;
  display: flex;
  font-family: 'IdealSans-Medium';
  font-size: 12px;
  height: 40px;
  justify-content: center;
  position: absolute;
  width: 120px;
  z-index: 15;

  &:focus {
    outline: none;
  }
}

.mobile-slide {
  background-color: #fff;
  display: block;
  margin: 0px;
  height: calc(100vh - 50px);
  overflow: hidden;
  position: absolute;
  top: 90px;
  transition: all ease-in-out .3s;
  width: 100vw;
  z-index: 2;

  @media only screen and (min-width: 1024px) {
    background-color: transparent;
    height: auto;
    height: unset;
    top: unset;
    transition: unset;
  }
}

.mobile-slide.open {
  top: 100sh;
  height: 0vh;
  overflow: scroll;
}


.listed-results {
  background-color: #fff;
  border-top: 1px solid #4e97b2;
  // border-radius: 0px 8px 0px 0px;
  -webkit-box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.17);
  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.17);
  display: block;
  margin: 0px;
  height: calc(100vh - 50px);
  overflow-y: scroll;
  padding: 0px;
  position: relative;
  scrollbar-width: none;
  -ms-overflow-style: none;
  top: 28px;
  transition: top .5s ease-in-out .7s;
  width: 100vw;
  z-index: 2;

  @media only screen and (min-width: 1024px) {
    -webkit-box-shadow: none;
    box-shadow: none;
    display: block;
    left: 0;
    max-height: calc(100vh - 150px);
    transition: unset;
    width: 100%;
    z-index: 0;
  }

  &.slide {
    top: 100svh;
    transition: top ease-in-out .5s;
    width: 100vw;
  }

  &::--webkit-scrollbar {
    display: none;
  }

  .mobile-slide {
    background-color: #fff;
    display: block;
    margin: 0px;
    height: calc(100vh - 50px);
    overflow: hidden;
    position: absolute;
    top: 60px;
    transition: all ease-in-out .3s;
    width: 100vw;
    z-index: 2;

    @media only screen and (min-width: 1024px) {
      background-color: transparent;
      height: auto;
      height: unset;
      top: unset;
      transition: unset;
    }
  }

  .mobile-slide.open {
    top: 100vh;
    height: 0vh;
    overflow: scroll;
  }

}
</style>
